export default {
  type: 'content-api',
  routes: [
    {
      method: 'POST',
      path: '/validate-init-data',
      handler: 'telegram-link.validateInitData'
    },
    {
      method: 'GET',
      path: '/linking/:bot/:service',
      handler: 'telegram-link.getLinking'
    },
    {
      method: 'POST',
      path: '/linking/:bot/:service',
      handler: 'telegram-link.setLinking'
    }
  ]
}
